<div class="w-full profile-container" *ngIf="!initialLoading">
    <div class="flex  flex-nowrap w-full p-3 gap-3 " style="overflow-x: scroll;">
        <p-toast />
        <div class="h-full relative">
            <p-card header="" class="flex h-[89vh]">
                <div class="flex space-x-2">

                    <div style="display: flex; align-items: center;">
                        <p-avatar class="mr-2" size="xlarge" shape="circle"
                            [image]="previewImage || studentDetails.photo_url || studentDetails.profile_pic"
                            *ngIf="studentDetails.photo_url != null || previewImage || studentDetails.profile_pic != null; else showInitials"
                            [style]="{
                            width: '60px',
                            height: '60px',
                            borderRadius: '50%',
                            cursor: 'pointer',
                            objectFit: 'cover',
                            border: '1px solid #ccc'
                          }" (click)="uploadInput.click()"></p-avatar>

                        <ng-template #showInitials>
                            <p-avatar class="mr-2" size="xlarge" shape="circle" label="{{ getInitials() }}" [style]="{
                              width: '60px',
                              height: '60px',
                              borderRadius: '50%',
                              fontSize: '30px',
                              cursor: 'pointer'
                            }" (click)="uploadInput.click()"></p-avatar>
                        </ng-template>

                        <input #uploadInput type="file" accept="image/*" (change)="onProfileImageUpload($event)"
                            style="display: none;" />
                    </div>

                    <div class="flex flex-col gap-3 justify-center">
                        <div class="flex flex-col gap-1">
                            <div class="text-[20px] font-bold ">
                                {{
                                getFullName()
                                }}
                            </div>
                            <div class="text-[13px]" *ngIf="student_profile_stage == 'admission'">
                                Admission No : {{ studentDetails.admission_number }}
                            </div>

                            <div class="text-[13px]" *ngIf="student_profile_stage == 'enrollment'">
                                Enrollment No : {{ studentDetails.enrollment_number }}
                            </div>

                            <div class="text-[13px]" *ngIf="student_profile_stage == 'application'">
                                Application No : {{ studentDetails.application_number }}
                            </div>

                            <div class="text-[13px]" *ngIf="student_profile_stage == 'registration'">
                                Registration No : {{ studentDetails.registration_id }}
                            </div>
                        </div>

                    </div>
                </div>

                <div class="flex items-center gap-2 mt-4 ml-2 max-w-[300px]">
                    <div class="text-[13px] break-all">
                        {{ studentDetails.email }}
                    </div>
                    <div>
                        <i class="pi pi-clone cursor-pointer" (click)="handleCopy()"></i>
                    </div>
                </div>


                <p-divider class="mt-2" class="divider"></p-divider>

                <h3 class="text-[20px] -mt-3 font-semibold mb-0">
                    Academic Details
                </h3>
                <!-- note this details can only be changed by admin -->
                <div class="mb-5">
                    <span class="text-[12px] text-gray-500 -mt-1"> (These details can only be changed by admin)</span>
                </div>


                <div class="flex flex-col gap-2 -mt-3" *ngIf="student_profile_stage == 'admission'">


                    <div class="mt-2">
                        <div class="mb-2 font-medium">Course</div>
                        <p-select [options]="allCourses" optionLabel="name" optionValue="course_id"
                            [(ngModel)]="selectedCourse" placeholder="Select Course" appendTo="body" [disabled]="true"
                            class="w-full rounded-sm profile-select" />
                    </div>

                    <!-- Department-->
                    <div class="mt-2">
                        <div class="mb-2 font-medium">Department</div>
                        <p-select [options]="departmentList" [(ngModel)]="selectedDepartment" appendTo="body"
                            optionLabel="name" optionValue="dept_id" placeholder="Select Department" [disabled]="true"
                            class="w-full rounded-sm profile-select" />
                    </div>

                    <!-- Academic Year -->
                    <div class="mt-2">
                        <div class="mb-2 font-medium">Academic Year</div>
                        <p-select [options]="academicYearList" optionValue="id" optionLabel="year_name"
                            [(ngModel)]="selectedAcademicYear" appendTo="body" placeholder="Select Academic Year"
                            [disabled]="true" class="w-full rounded-sm profile-select" />
                    </div>

                    <!-- Batch-->
                    <div class="mt-2">
                        <div class="mb-2 font-medium">Batch</div>
                        <p-select [options]="batchList" [(ngModel)]="selectedBatch" appendTo="body"
                            optionLabel="batch_name" optionValue="id" placeholder="Select Batch" [disabled]="true"
                            class="w-full rounded-sm profile-select" />
                    </div>

                    <!-- Fee Category -->
                    <div class="mt-2 ">
                        <div class="mb-2 font-medium">Fee Category</div>
                        <p-select [options]="feeCategoryList" [(ngModel)]="selectedFeeCategory" optionLabel="group_name"
                            optionValue="id" appendTo="body" placeholder="Select Fee Category" [disabled]="true"
                            class="w-full rounded-sm profile-select" />
                    </div>


                    <div class="mt-2">
                        <div class="mb-2 font-medium">Hostel Category</div>
                        <p-select [options]="hostelCategoryList" [(ngModel)]="selectedHostelCategory"
                            optionLabel="hostel_name" optionValue="id" appendTo="body" [disabled]="true"
                            placeholder="Select Hostel Category" class="w-full rounded-sm profile-select" />
                    </div>


                    <div class="mt-2 ">
                        <div class="mb-2 font-medium">Transport Category</div>
                        <p-select [options]="transportRouteList" [(ngModel)]="selectedTransportRoute"
                            optionLabel="route_name" optionValue="id" appendTo="body" [disabled]="true"
                            placeholder="Select Transport Category" class="w-full rounded-sm profile-select" />
                    </div>

                    <div class="mt-2 mb-16">
                        <div class="mb-2 font-medium">Scholarship Category</div>
                        <p-select [options]="scholarshipTypeList" [(ngModel)]="selectedScholarshipType"
                            optionLabel="name" optionValue="scholarship_id" appendTo="body" [disabled]="true"
                            placeholder="Select Scholarship Category" class="w-full rounded-sm profile-select" />
                    </div>


                </div>


                <div class="flex flex-col gap-2 -mt-3" *ngIf="student_profile_stage == 'enrollment'">

                    <div class="mt-2">
                        <div class="mb-2 font-medium">Assigned To</div>
                        <p-select [options]="users" [(ngModel)]="studentDetails.assign_to" [disabled]="true"
                            optionLabel="name" optionValue="user_id" placeholder="Select Assigned To"
                            class="w-full rounded-sm profile-select" appendTo="body" />
                    </div>

                    <div class="mt-2">
                        <div class="mb-2 font-medium">Enrollment Status</div>
                        <p-select appendTo="body" [options]="enrollmentStatusList" [disabled]="true"
                            [(ngModel)]="studentDetails.enrollment_status" placeholder="Select Enrollment Status"
                            class="w-full rounded-sm profile-select" />
                    </div>


                    <div class="mt-2">
                        <label class="block mb-2 requiredValue">Document Status</label>
                        <p-select class="w-full shadow-none" appendTo="body"
                            [(ngModel)]="studentDetails.document_status" name="document_status"
                            [options]="documentStatusList" required [disabled]="true">
                        </p-select>
                    </div>

                    <div class="mt-2">
                        <label class="block mb-2 requiredValue">Mode of Study</label>
                        <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="studentDetails.mode_of_study"
                            name="mode_of_study" [options]="modeOfStudyList" required [disabled]="true">
                        </p-select>
                    </div>


                    <div class="mt-2">
                        <label class="block mb-2 requiredValue">Course</label>
                        <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="studentDetails.course_id"
                            name="course" [options]="allCourses" required [disabled]="true" optionLabel="name"
                            optionValue="course_id">
                        </p-select>
                    </div>

                </div>

                <div class="flex flex-col gap-2 -mt-3" *ngIf="student_profile_stage == 'application'">

                    <div class="mt-2">
                        <div class="mb-2 font-medium">Assigned To</div>
                        <p-select [options]="users" [(ngModel)]="studentDetails.assign_to" [disabled]="true"
                            optionLabel="name" optionValue="user_id" placeholder="Select Assigned To"
                            class="w-full rounded-sm profile-select" appendTo="body" />
                    </div>

                    <div class="mt-2">
                        <div class="mb-2 font-medium">Application Status</div>
                        <p-select appendTo="body" [options]="applicationStatusList" [disabled]="true"
                            [(ngModel)]="studentDetails.status" placeholder="Select Application Status"
                            class="w-full rounded-sm profile-select" />
                    </div>


                    <div class="mt-2">
                        <label class="block mb-2 requiredValue">Document Status</label>
                        <p-select class="w-full shadow-none" appendTo="body"
                            [(ngModel)]="studentDetails.document_status" name="document_status"
                            [options]="documentStatusList" required [disabled]="true">
                        </p-select>
                    </div>
                    
                    <div class="mt-2">
                        <label class="block mb-2 requiredValue">Course</label>
                        <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="studentDetails.course_id"
                            name="course" [options]="allCourses" required [disabled]="true" optionLabel="name"
                            optionValue="course_id">
                        </p-select>
                    </div>

                </div>


                  <div class="flex flex-col gap-2 -mt-3" *ngIf="student_profile_stage == 'registration'">

                    <div class="mt-2">
                        <div class="mb-2 font-medium">Assigned To</div>
                        <p-select [options]="users" [(ngModel)]="studentDetails.assigned_to" [disabled]="true"
                            optionLabel="name" optionValue="user_id" placeholder="Not Assigned"
                            class="w-full rounded-sm profile-select" appendTo="body" />
                    </div>

                    <div class="mt-2">
                        <div class="mb-2 font-medium">Registration Status</div>
                        <p-select appendTo="body" [options]="registrationStatusList" [disabled]="true"
                            [(ngModel)]="studentDetails.status" placeholder="Select Registration Status"
                            class="w-full rounded-sm profile-select" />
                    </div>


                    <div class="mt-2">
                        <label class="block mb-2 requiredValue">Document Status</label>
                        <p-select class="w-full shadow-none" appendTo="body"
                            [(ngModel)]="studentDetails.document_status" name="document_status"
                            [options]="documentStatusList" required [disabled]="true">
                        </p-select>
                    </div>
                    
                    <div class="mt-2">
                        <label class="block mb-2 requiredValue">Course</label>
                        <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="studentDetails.preferred_course"
                            name="course" [options]="allCourses" required [disabled]="true" optionLabel="name"
                            optionValue="course_id"
                            placeholder="Not Selected"
                            >
                        </p-select>
                    </div>

                </div>



                <!-- <div class="mt-8 flex items-center gap-2 absolute  bottom-buttons">
                    <p-button label="Back" icon="pi pi-arrow-left" (onClick)="handleBack()" severity="secondary" />
                    <p-button label="Save" class="w-full" [loading]="loading" (onClick)="handleSaveQuickActions()"
                        [disabled]="loading" />

                </div> -->

            </p-card>
        </div>

        <div class="flex-1" style="min-width: 350px;">
            <app-student-temp-profile-middle-screen [editLeadData]="editLeadData" [users]="users"
                [studentDetails]="studentDetails" [allCourses]="allCourses" [academicYearList]="academicYearList"
                [departmentList]="departmentList" [batchList]="batchList"
                [student_profile_stage]="student_profile_stage" [feeCategoryList]="feeCategoryList"
                [hostelCategoryList]="hostelCategoryList" [transportRouteList]="transportRouteList"
                [scholarshipTypeList]="scholarshipTypeList" [selectedTabIdx]="selectedTabIdx" [fullUser]="fullUser"
                [allLeadFeilds]="allLeadFeilds" (tabChanged)="selectedTabIdx = $event">
            </app-student-temp-profile-middle-screen>
        </div>
    </div>
</div>

<div *ngIf="initialLoading" class="h-screen w-full flex items-center justify-center">
    <p-progressSpinner></p-progressSpinner>
</div>